import styled from "styled-components";

const SoonStyled = styled.div`
  position: absolute;
  top:0;
  right:0;
  bottom:0;
  left:0;
  background:#ffffff87;
  display:flex;
  justify-content:center;
  align-items:center;
  font-size: 30px;
`;

export { SoonStyled };
